import React, { useEffect, useState } from "react";
import "./RealizarVenta.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { fetchProducts } from "../../services/getProducts";
import { fetchCategories } from "../../services/getCategories";

const RealizarVenta = () => {
  const [categorias, setCategories] = useState([]);
  const [categoriesWithID, setCategoriesWithID] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Todo");
  const [subCategorias, setSubCategorias] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [products, setProducts] = useState([]);
  const [update, setUpdate] = useState("");
  const [id, setId] = useState("");
  const [query, setQuery] = useState(""); // Estado para el valor del input
  const [searchQuery, setSearchQuery] = useState(""); // Estado para la búsqueda real
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 21;
  const [quantities, setQuantities] = useState({});

  useEffect(() => {
    const loadCategories = async () => {
      const [fetchedCategoriesWithID, fetchedCategorias] =
        await fetchCategories();
      setCategoriesWithID(fetchedCategoriesWithID);
      setCategories(fetchedCategorias);
    };
    loadCategories();
  }, []);

  useEffect(() => {
    const loadProducts = async () => {
      const data = await fetchProducts(update, id, searchQuery); // Usar searchQuery en lugar de query
      setProducts(data);
      setCurrentPage(1); // Reiniciar a la primera página después de una búsqueda
      console.log(data);
    };
    loadProducts();
  }, [update, id, searchQuery]); // Depender de searchQuery

  const handleSearchChange = (event) => setQuery(event.target.value);

  const handleSearch = () => {
    setSearchQuery(query); // Actualizar searchQuery con el valor actual de query
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch(); // Llamar a handleSearch al presionar "Enter"
    }
  };

  const handleChangeCategory = (event) => {
    const category = event.target.value;
    setSelectedCategory(category);
    if (category === "Todo") {
      setUpdate(0);
      setSubCategorias([]);
      setSelectedSubcategory("");
    } else {
      const selectedCategoryObj = categoriesWithID.find(
        (cat) => cat.label === category
      );
      if (selectedCategoryObj) {
        setId(selectedCategoryObj.id);
        setUpdate(1);
        setSubCategorias(
          selectedCategoryObj.subcategories.map((sub) => sub.label)
        );
        setSelectedSubcategory("");
      } else {
        setSubCategorias([]);
        setSelectedSubcategory("");
      }
    }
  };

  const handleChangeSubcategory = (event) => {
    const subcategory = event.target.value;
    setSelectedSubcategory(subcategory);
    const selectedCategoryObj = categoriesWithID.find(
      (cat) => cat.label === selectedCategory
    );
    if (selectedCategoryObj) {
      const selectedSubcategoryObj = selectedCategoryObj.subcategories.find(
        (sub) => sub.label === subcategory
      );
      if (selectedSubcategoryObj) {
        setId(selectedSubcategoryObj.id);
      }
    }
  };

  const handleQuantityChange = (productId, stock, value) => {
    const quantity = Math.min(Math.max(Number(value), 1), 100);
    setQuantities((prev) => ({ ...prev, [productId]: quantity }));
  };

  const handleAddToCart = (productId) => {
    const quantity = quantities[productId] || 0;

    if (quantity > 0) {
      const product = products.find((p) => p.id === productId);
      if (!product) {
        alert("Error: Producto no encontrado.");
        return;
      }

      const storedCart =
        JSON.parse(localStorage.getItem("carritoActual")) || [];

      const existingProductIndex = storedCart.findIndex(
        (item) => item.id === productId
      );

      if (existingProductIndex !== -1) {
        storedCart[existingProductIndex].cantidad += quantity;
      } else {
        storedCart.push({
          id: productId,
          label: product.label,
          cantidad: quantity,
          precio: product.price,
        });
      }

      localStorage.setItem("carritoActual", JSON.stringify(storedCart));

      alert(`Producto agregado con éxito. Cantidad: ${quantity}`);
    } else {
      alert("Debes agregar al menos 1 unidad.");
    }
  };

  // Paginación
  const totalPages = Math.ceil(products.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProducts = products.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <div className="realizar-venta-container">
      <div className="main-content">
        {/* Categorías */}
        <div className="category-selector">
          <h2 className="section-title">Categorías</h2>
          <div className="categories-options">
            {categorias.map((categoria, index) => (
              <button
                key={index}
                className={`category-btn ${
                  selectedCategory === categoria ? "active" : ""
                }`}
                onClick={handleChangeCategory}
                value={categoria}
              >
                {categoria}
              </button>
            ))}
          </div>
          {subCategorias.length > 0 && (
            <div className="subcategory-selector">
              <h3 className="subsection-title">Subcategorías</h3>
              {subCategorias.map((subcategoria, index) => (
                <button
                  key={index}
                  className={`subcategory-btn ${
                    selectedSubcategory === subcategoria ? "active" : ""
                  }`}
                  onClick={handleChangeSubcategory}
                  value={subcategoria}
                >
                  {subcategoria}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Búsqueda */}
        <div className="search-section">
          <input
            type="search"
            placeholder="Buscar..."
            value={query}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            className="search-input"
          />
          <button onClick={handleSearch} className="search-btn">
            Buscar
          </button>
        </div>

        {/* Productos */}
        <div className="product-grid">
          {currentProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-name">{product.label}</div>
              <div className="product-precio">
                Precio: {parseInt(product.price).toFixed(0)} ₡
              </div>
              <input
                type="number"
                min="0"
                max="100"
                value={quantities[product.id] || 0}
                onChange={(e) =>
                  handleQuantityChange(
                    product.id,
                    product.stock_reel,
                    e.target.value
                  )
                }
                className="quantity-input"
              />

              <button
                onClick={() => handleAddToCart(product.id)}
                className="add-btn"
              >
                Agregar
              </button>
            </div>
          ))}
        </div>

        {/* Paginación */}
        <div className="pagination-container">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              className={`pagination-item ${
                currentPage === index + 1 ? "active" : ""
              }`}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RealizarVenta;
